var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#28C76F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 8,
    fill: "#28C76F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenimg);
export default __webpack_public_path__ + "static/media/Green img.65047d7faf534d400d19103395f4dd31.svg";
export { ForwardRef as ReactComponent };